import {INavStyles} from "@fluentui/react/lib/Nav";
import {FontWeights, mergeStyleSets} from "@fluentui/react/lib/Styling";
import {IStackStyles} from "office-ui-fabric-react";
import {Theme} from "@fluentui/react-theme-provider";

export const nonShrinkingStackItemStyles: IStackStyles = {
    root: {

        padding: 12,
        overflow: 'hidden',
        alignItems: "center",
    },
}

export const navStyles: Partial<INavStyles> = {
    link: {
        whiteSpace: 'normal',
        lineHeight: 'inherit'
    }
}

export const iconButtonStyles = {
    root: {
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    }
}

export interface IContentStyles {
    emailPreviewTags: string
    contentControls: string
    typeApprove: string
    typeComplete: string
    typeReject: string
    typeAbort: string
    newContainer: string
    container: string
    containerRecord: string
    containerListEdit: string
    containerUpload: string
    containerRecordPreview: string
    containerListPreview: string
    containerApprovalNote: string
    containerOverride: string
    containerResponseActions: string
    containers: string
    fileIconImg: string
    fileIconHeaderIcon: string
    fileIconCell: string
    header: string
    body: string
    bodyGeneral: string
    bodyList: string
    bodyExample: string
    bodyExamples: string
    containerMail: string
    User: string
    SpinnerActive: string
}


export const contentStyles = (theme: Theme): IContentStyles => {

    return mergeStyleSets({
        emailPreviewTags: {
            backgroundColor: '#e8e8e8',
            padding: '4px 8px',
            color: '#4a4a4a',
            width: 'fit-content',
            borderRadius: '4px',
            marginLeft: 4,
            marginRight: 4
        },
        contentControls: {
            backgroundColor: '#e8e8e8',
            padding: '4px 8px',
            color: '#4a4a4a',
            width: 'fit-content',
            borderRadius: '4px'
        },
        typeApprove: {
            backgroundColor: '#d4edda',
            display: 'block',
            padding: '4px 8px',
            fontWeight: FontWeights.semibold,
            borderRadius: '4px',
            color: '#28a745'
        },
        typeComplete: {
            backgroundColor: '#cce5ff',
            display: 'block',
            padding: '4px 8px',
            fontWeight: FontWeights.semibold,
            borderRadius: '4px',
            color: '#0078d4'
        },
        typeReject: {
            backgroundColor: '#f8d7da',
            display: 'block',
            padding: '4px 8px',
            fontWeight: FontWeights.semibold,
            borderRadius: '4px',
            color: '#d32f2f'
        },
        typeAbort: {
            backgroundColor: '#dddddd',
            display: 'block',
            padding: '4px 8px',
            fontWeight: FontWeights.semibold,
            borderRadius: '4px',
            color: '#3c3c3c'
        },
        newContainer: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "90vh",
            minWidth: '320px',
            overflow: "hidden",
            width: '65vw'
        },
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
            width: '65vw'
        },
        containerRecord: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
            maxWidth: '480px',
            width: '480px',
        },
        containerListEdit: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "320px",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '480px',
            width: '480px'
        },
        containerUpload: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "420px",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '480px',
            width: '480px'
        },
        containerRecordPreview: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "80vh",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '720px',
            width: '720px'
        },
        containerListPreview: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "60vh",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '50vw',
            width: '50vw'
        },
        containerApprovalNote: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "70vh",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '60vw',
            width: '60vw'
        },
        containerOverride: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "320px",
            minHeight: "240px",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '480px',
            width: '480px'
        },
        containerResponseActions: {
            borderTop: `4px solid ${theme.palette.themePrimary}`,
            display: 'flex',
            height: "70vh",
            minHeight: "320px",
            minWidth: '320px',
            overflow: "hidden",
            maxWidth: '480px',
            width: '480px'
        },
        containers: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
            width: window.innerWidth > 1800 ? '45vw' : '65vw',
        },
        fileIconImg: {
            verticalAlign: 'middle',
            maxHeight: '16px',
            maxWidth: '16px',
            color: 'rgb(96, 94, 92)'
        },
        fileIconHeaderIcon: {
            padding: 0,
            fontSize: "16px",
        },
        fileIconCell: {
            textAlign: "center",
            selectors: {
                "&:before": {
                    content: ".",
                    display: "inline-block",
                    verticalAlign: "middle",
                    height: "100%",
                    width: "0px",
                    visibility: "hidden",
                },
            },
        },
        header: [
            theme.fonts.xLarge,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.black,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 0px 24px',
            },
        ],
        body: {
            height: window.innerHeight > 660 ? '63vh' : '58vh',
            flex: '4 4 auto',
            padding: '0 15px 24px 15px',
            selectors: {
                p: {margin: '14px 0'},
                'p:first-child': {marginTop: 0},
                'p:last-child': {marginBottom: 0},
            },
        },
        bodyGeneral: {
            height: window.innerHeight > 660 ? '63vh' : '58vh',
            flex: '4 4 auto',
            padding: '0 15px 24px 15px',
            selectors: {
                p: {margin: '14px 0'},
                'p:first-child': {marginTop: 0},
                'p:last-child': {marginBottom: 0},
            },
        },
        bodyList: {
            width: '70vw',
            height: '75vh',
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            selectors: {
                p: {margin: '14px 0'},
                'p:first-child': {marginTop: 0},
                'p:last-child': {marginBottom: 0},
            },
        },
        bodyExample: {
            height: window.innerHeight > 660 ? '63vh' : '58vh',
            flex: '4 4 auto',
            padding: '0 15px 24px 15px',
            selectors: {
                p: {margin: '14px 0'},
                'p:first-child': {marginTop: 0},
                'p:last-child': {marginBottom: 0},
            },
        },
        bodyExamples: {
            height: window.innerHeight > 660 ? '50vh' : '50vh',
            flex: '4 4 auto',
            padding: '0 15px 24px 15px',
            selectors: {
                p: {margin: '14px 0'},
                'p:first-child': {marginTop: 0},
                'p:last-child': {marginBottom: 0},
            },
        },
        containerMail: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
            width: '30vw',
            height: '20vh',
        },
        User: {
            width: '25vw',
            height: '20vh',
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            selectors: {
                p: {margin: '14px 0'},
                'p:first-child': {marginTop: 0},
                'p:last-child': {marginBottom: 0},
            },
        },
        SpinnerActive: {
            pointerevents: 'none!important'
        }
    })
}
